<template>
  <accordion
    :expanded="expanded"
    :title="topic.title"
    @accordion-toggled="toggle"
  >
    <slot />
  </accordion>
</template>

<script>
import Accordion from '@components/ui/accordion';

export default {
  components: { Accordion },
  props: {
    expanded: {
      type: Boolean,
      default: false,
    },
    topic: {
      type: Object,
    },
  },
  emits: ['accordion-toggled'],
  methods: {
    toggle() {
      this.$emit('accordion-toggled', this.topic);
    },
  },
};
</script>
